export default __webpack_public_path__ + "static/mean-cycle-1-m-4b19651c5ba2ee27ed0756b96ca39dd7.svg";